/**
 * Вырезать учётные данные из тела запроса перед печатью в консоль.
 *
 * Отладка (`config.debug`) нужна в работе и остаётся — решение владельца
 * 08.09.2026. Но пароль для отладки не нужен ни в каком режиме: видеть, что
 * происходит с запросом, и знать его значение — разные вещи. Найдено при
 * приёмке T046: неудачный вход лёг в консоль целиком, вместе с паролем
 * административной учётной записи, под которой работают сотрудники УК (T049).
 *
 * Режется **на местах печати**, а не у вызывающего: вызывающих легко забыть.
 * Мест два, и оба закрыты — тело запроса и тело ответа: в ответе на вход лежит
 * то, ради чего пароль и вводят, то есть рабочий токен доступа.
 *
 * Всё остальное тело печатается как было — иначе мы починили бы одно и сломали
 * то, ради чего отладка включена.
 */

// Имена полей, значение которых не нужно ни одному разбору. Совпадение по
// вхождению, без учёта регистра. `code` сюда НЕ входит намеренно: это рабочее
// поле (коды отчётов, участков, ошибок), и вырезать его — сломать отладку.
const SECRET_KEYS = [
  // `pass` покрывает и `password`, и `oldpass`/`newpass` из смены пароля
  // в профиле — там в лог ложились ОБА пароля сразу, то есть готовая пара.
  "pass",
  "pwd",
  "secret",
  "token",
  // Тикет восстановления и ответ на секретный вопрос вместе позволяют сменить
  // пароль, не зная его: вырезать замок, оставив ключ рядом, бессмысленно.
  "ticket",
  "securityanswer",
  // Заголовок авторизации несёт `Bearer <токен>` и печатался на КАЖДОМ запросе —
  // чаще всего прочего в этом списке.
  "authorization",
  // Код сессии приходит вместе с токенами и открывает канал уведомлений
  // (`websocket.js:195` строит по нему URL). Рабочих полей с таким именем
  // в телах запросов нет — `/session/set/oper_date` это путь, а не поле.
  "session",
];

const MASK = "***";

// Имена, которые описывают учётные данные, но ими не являются. `subject_token_type`
// — это `urn:ietf:params:oauth:token-type:access_token`, то есть КАКОЙ токен
// обменивают; без него в логе не видно, что за обмен идёт, а ради этого отладку
// и держат. Поймано положительным контролем, а не рассуждением.
// Именно `^type$|_type$`, а не `_type` где угодно: исключение заведено ради
// одного ключа, и широкая форма сняла бы защиту с целого класса имён вперёд
// (`token_type_secret` прошёл бы насквозь).
const DESCRIPTOR = /^type$|_type$/;

const isSecretKey = (key) => {
  const k = String(key).toLowerCase();
  if (DESCRIPTOR.test(k)) {
    return false;
  }
  return SECRET_KEYS.some((s) => k.includes(s));
};

const redactCredentials = (value) => {
  if (Array.isArray(value)) {
    return value.map(redactCredentials);
  }
  if (value && typeof value === "object") {
    // Дата, moment и dayjs сериализуются через `toJSON`, а обход по ключам его
    // не зовёт: без этой ветки дата в отладке превратилась бы в `{}`, а moment —
    // в две тысячи байт внутренностей. Отладку держат ради экранов «Отчёты»
    // и «Импорт», где даты в теле запроса как раз и ездят.
    if (typeof value.toJSON === "function") {
      return value.toJSON();
    }
    const out = {};
    Object.keys(value).forEach((key) => {
      // Маскируем только строки. Учётные данные строками и бывают, а под теми же
      // именами ходят рабочие поля других типов: `passwordchange` — булев флаг
      // политики, и `true` от `false` в логе должно быть отличимо. Плюс `undefined`
      // так не превращается в «***» — иначе лог утверждал бы, что пароль
      // отправляли, когда его в запросе не было вовсе.
      const v = value[key];
      // Маска фиксированная: длина пароля — тоже сведение о нём.
      out[key] = isSecretKey(key) && typeof v === "string" ? MASK : redactCredentials(v);
    });
    return out;
  }
  return value;
};

export default redactCredentials;
